"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { isLightPage } from "@/lib/light-pages";

function getPageBackground(pathname: string): string {
  if (isLightPage(pathname)) return "#f3f3f3";
  if (pathname.startsWith("/admin")) {
    const adminRoot = document.querySelector(".admin-page");
    if (adminRoot?.getAttribute("data-admin-theme") === "light") {
      return "#f0f2f7";
    }
    return "#0c0f15";
  }
  return "#1C1C1C";
}

export function MetaTheme() {
  const pathname = usePathname();

  useEffect(() => {
    const setMetaTag = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", name);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    };

    const applyPageBackground = () => {
      const pageBg = getPageBackground(pathname);

      setMetaTag("theme-color", pageBg);
      setMetaTag("msapplication-navbutton-color", pageBg);
      setMetaTag("msapplication-TileColor", pageBg);
      document.documentElement.style.backgroundColor = pageBg;
      document.body.style.backgroundColor = "transparent";
    };

    setMetaTag("apple-mobile-web-app-status-bar-style", "black-translucent");
    setMetaTag("apple-mobile-web-app-capable", "yes");
    setMetaTag("mobile-web-app-capable", "yes");

    const setHttpEquivTag = (equiv: string, content: string) => {
      let meta = document.querySelector(`meta[http-equiv="${equiv}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("http-equiv", equiv);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    };
    setHttpEquivTag("Permissions-Policy", "payment=(self)");

    applyPageBackground();

    const adminRoot = document.querySelector(".admin-page");
    let observer: MutationObserver | null = null;
    if (adminRoot) {
      observer = new MutationObserver(() => {
        applyPageBackground();
      });
      observer.observe(adminRoot, {
        attributes: true,
        attributeFilter: ["data-admin-theme"],
      });
    }

    return () => {
      observer?.disconnect();
      document.body.style.backgroundColor = "";
      document.documentElement.style.backgroundColor = "";
    };
  }, [pathname]);

  return null;
}
